import axios from 'axios';
import router from '../router';
import store from '../store';

axios.interceptors.response.use(
    (response) => {
        if (response.status === 200) {
            return response;
        }
        return null;
    },
    (error) => {
        if (error.response && error.response.status === 401) {
            window.localStorage.clear();
            window.location.href = '/';
        }
        console.log(error);
        if (error.response && error.response.status === 500) {
            router.push('/500');
            store.commit('setDataLoaded', true);
        }
        if (error.response) {
            return Promise.reject(error.response);
        }
        return Promise.reject(error);
    },
);
